// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"494ae8ea","141":"5492ce0f","205":"cf7cf90b","207":"4d568e00","220":"5bf8914c","255":"3bc21ba6","395":"24ebf7f7","859":"694d4175","935":"18674244","983":"abc2034d"}[chunkId] + ".chunk.css";
};